import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';

export type FlightCheckTab = 'dashboard' | 'analysis';

const TAB_ROUTES = {
  dashboard: '/flight-check/dashboard',
  analysis: '/flight-check/analysis',
} as const satisfies Record<FlightCheckTab, string>;

/** Switches between the two Flight Check overview pages; the selected tab is the current route. */
export function FlightCheckTabs({ value }: { value: FlightCheckTab }): ReactNode {
  const navigate = useNavigate();
  return (
    <Tabs
      value={value}
      onChange={(_event, next: FlightCheckTab) => void navigate({ to: TAB_ROUTES[next] })}
    >
      <Tab value="dashboard" label="Dashboard" />
      <Tab value="analysis" label="Analysis" />
    </Tabs>
  );
}
